"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setPageForGoogleAnalytics = exports.getChatByMembers = exports.getChannelById = exports.getChatFromState = exports.amIFollowing = exports.getChatChannels = exports.streamChatConnect = exports.getUserById = exports.getGetstreamToken = exports.getNotificationFeed = exports.getUserFeed = exports.getTimeline = exports.streamConnectById = exports.streamConnect = void 0;
var getstream_1 = __importDefault(require("getstream"));
var stream_chat_1 = require("stream-chat");
var axios_1 = __importDefault(require("axios"));
var react_ga_1 = __importDefault(require("react-ga"));
var KEY = 'nbdfauwm6ek3';
var APPID = '43935';
var CHAT_NAME_PREFIX = 'private';
var streamConnect = function (userToken) {
    var client = getstream_1.default.connect(KEY, userToken, APPID);
    return client;
};
exports.streamConnect = streamConnect;
var streamConnectById = function (userId) {
    return (0, exports.getGetstreamToken)(userId).then(function (getstreamToken) {
        return (0, exports.streamConnect)(getstreamToken);
    });
};
exports.streamConnectById = streamConnectById;
var getTimeline = function (client, userId) {
    return client.feed('timeline', userId);
};
exports.getTimeline = getTimeline;
var getUserFeed = function (client, userId) {
    return client.feed('user', userId);
};
exports.getUserFeed = getUserFeed;
var getNotificationFeed = function (client, userId) {
    return client.feed('notification', userId);
};
exports.getNotificationFeed = getNotificationFeed;
var getGetstreamToken = function (userId) {
    return axios_1.default
        .get("".concat(process.env.REACT_APP_BACKEND_DOMAIN, "/api/v2/token/").concat(userId))
        .then(function (response) { return response.data.getstreamToken; });
};
exports.getGetstreamToken = getGetstreamToken;
var getUserById = function (userId) {
    return axios_1.default
        .get("".concat(process.env.REACT_APP_BACKEND_DOMAIN, "/api/v2/user/").concat(userId))
        .then(function (response) { return response.data; });
};
exports.getUserById = getUserById;
var streamChatConnect = function (userId) {
    var client = new stream_chat_1.StreamChat(KEY);
    return Promise.all([(0, exports.getGetstreamToken)(userId), (0, exports.getUserById)(userId)]).then(function (_a) {
        var getstreamToken = _a[0], userData = _a[1];
        client.setUser({
            id: userId.toString(),
            name: userData.name,
            image: userData.avatarUrl
        }, getstreamToken);
        return client;
    });
};
exports.streamChatConnect = streamChatConnect;
var getChatChannels = function (client, userId, page) { return __awaiter(void 0, void 0, void 0, function () {
    var filters, sort, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                filters = {
                    members: { $in: [userId.toString()] },
                    trybePrivateMessagingChat: true
                };
                sort = { last_message_at: -1 };
                return [4 /*yield*/, client.queryChannels(filters, sort, {
                        limit: 10,
                        offset: page * 10
                    })];
            case 1:
                result = _a.sent();
                return [2 /*return*/, result.map(function (channel) { return setChannelAvatar(userId, channel); })];
        }
    });
}); };
exports.getChatChannels = getChatChannels;
var amIFollowing = function (id, following) {
    for (var i = 0; i < following.length; i++) {
        if (following[i].person.id == id)
            return true;
    }
    return false;
};
exports.amIFollowing = amIFollowing;
/**
 * Finds the chat id between current user and target user
 * @param {String} targetId
 * @param {String} userId
 */
var getChatFromState = function (chat1, chat2, channels) {
    for (var i = 0; i < channels.length; i++) {
        if (channels[i].id === chat1 || channels[i].id === chat2) {
            return channels[i];
        }
    }
    return null;
};
exports.getChatFromState = getChatFromState;
/**
 *
 * @param {String} userId - current user
 * @param {*} channel - object of the chat
 */
var setChannelAvatar = function (userId, channel) {
    var creatorId = channel.id.split('-')[1];
    channel.data.channelImage = (userId == creatorId) ? channel.state.members.undefined.user.image : channel.data.created_by.image;
    return channel;
};
var getChannelById = function (id, chatClient) { return __awaiter(void 0, void 0, void 0, function () {
    var filter, sort, channels;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                filter = { id: id };
                sort = { last_message_at: -1 };
                return [4 /*yield*/, chatClient.queryChannels(filter, sort, {
                        state: true
                    })];
            case 1:
                channels = _a.sent();
                if (channels.length > 1)
                    throw new Error('Warning! Found two channels!');
                return [2 /*return*/, channels.length !== 0 ? channels[0] : null];
        }
    });
}); };
exports.getChannelById = getChannelById;
var getChatByMembers = function (userId, targetId, channels) { return __awaiter(void 0, void 0, void 0, function () {
    var chat1, chat2, con, fromState, chatClient;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                chat1 = "".concat(CHAT_NAME_PREFIX, "-").concat(userId, "-").concat(targetId);
                chat2 = "".concat(CHAT_NAME_PREFIX, "-").concat(targetId, "-").concat(userId);
                con = (0, exports.getChatFromState)(chat1, chat2, channels);
                fromState = true;
                if (!!con) return [3 /*break*/, 5];
                return [4 /*yield*/, (0, exports.streamChatConnect)(userId)];
            case 1:
                chatClient = _a.sent();
                return [4 /*yield*/, (0, exports.getChannelById)(chat1, chatClient)];
            case 2:
                con = _a.sent();
                if (!!con) return [3 /*break*/, 4];
                return [4 /*yield*/, (0, exports.getChannelById)(chat2, chatClient)];
            case 3:
                con = _a.sent();
                _a.label = 4;
            case 4:
                if (con)
                    fromState = false;
                _a.label = 5;
            case 5: return [2 /*return*/, {
                    channel: con,
                    fromState: fromState
                }];
        }
    });
}); };
exports.getChatByMembers = getChatByMembers;
var setPageForGoogleAnalytics = function (pageName) {
    react_ga_1.default.pageview("/".concat(pageName));
};
exports.setPageForGoogleAnalytics = setPageForGoogleAnalytics;
